/**
 * Internal dependencies
 */
import SITE_META_ACTION from '@naruto/bgdcms/src/reducers/cores/site-meta/events';
import { SetSiteMetaContentInitialAction, SetSiteMetaInfoAction, SiteMetaInfo } from './types';

/* Initial */
export const SET_SITE_META_INITIALIZE = (): SetSiteMetaContentInitialAction => ({
  type: SITE_META_ACTION.SET_SITE_META_INITIALIZE
});

/* SiteMeta Action */
export const SET_SITE_META_INFO = ({ siteMetaInfo }: { siteMetaInfo: SiteMetaInfo }): SetSiteMetaInfoAction => ({
  type: SITE_META_ACTION.SET_SITE_META_INFO,
  siteMetaInfo
});
